// extracted by mini-css-extract-plugin
module.exports = {"imagesSlider":"Slider_imagesSlider__3GQyV","noOffset":"Slider_noOffset__5S8Hn"};